import { render, staticRenderFns } from "./NewClientList.vue?vue&type=template&id=1432521c&"
import script from "./NewClientList.vue?vue&type=script&lang=js&"
export * from "./NewClientList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports